import axios from 'axios';
import { appCheck } from '../firebase';
import { getToken } from 'firebase/app-check';

/**
 * AXIOS REQUEST INTERCEPTOR
 * Automatically attaches Firebase App Check token to every outgoing request.
 */
axios.interceptors.request.use(async (config) => {
    // Only attach token if App Check is initialized and available
    if (appCheck) {
        try {
            // getToken(appCheck, false) gets a fresh token if expired, otherwise returns cached.
            const appCheckTokenResponse = await getToken(appCheck, false);
            if (appCheckTokenResponse && appCheckTokenResponse.token) {
                config.headers['X-Firebase-AppCheck'] = appCheckTokenResponse.token;
            }
        } catch (error) {
            // Warn but do not block the request. 
            // In strict mode, the backend will reject it, which is correct.
            console.warn("Global App Check: Failed to retrieve token", error);
        }
    }
    // Auto-inject Auth token if present
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

/**
 * AXIOS RESPONSE INTERCEPTOR
 * Automatically handles 401 Unauthorized errors by logging the user out.
 */
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            console.warn("Session expired (401). Logging out...");

            // 1. Clear Local Storage
            localStorage.removeItem('token');
            localStorage.removeItem('userId');
            localStorage.removeItem('userEmail');
            localStorage.removeItem('userStatus');

            // 2. Clear Auth Header
            delete axios.defaults.headers.common['Authorization'];

            // 3. Notify App
            window.dispatchEvent(new Event('auth:changed'));

            // 4. Redirect to login (if not already there)
            if (!window.location.hash.includes('/login')) {
                window.location.href = '/#/login';
            }
        }
        return Promise.reject(error);
    }
);

export default axios;
